import React from 'react';
import { Box, Icon, IconButton, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Divider } from '../../../ui-kit';
import { generateTranslationByVenueType } from '../../../utils';
import { useUser } from '../../../utils/hooks/auth';

interface RecipeLineWrapperProps {
    recipeLineIndex: number;
    onRemove: () => void;
}

const RecipeLineWrapper: React.FC<RecipeLineWrapperProps> = ({ recipeLineIndex, onRemove, children }) => {
    const { t } = useTranslation();
    const { user: { venueType } } = useUser();

    return (
        <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
            <Box display="flex" style={{ width: '100%' }} justifyContent="space-between" alignItems="center">
                <Typography style={{ minWidth: '120px' }} variant="subtitle1">
                    {generateTranslationByVenueType({
                                    translations: {
                                        Ecommerce: t('Composite line {{lineNum}}', { lineNum: recipeLineIndex + 1 }),
                                        Restaurant: t('Recipe line {{lineNum}}', { lineNum: recipeLineIndex + 1 })
                                    },
                                    venueType,
                                })}
                </Typography>
                <Divider />
                <IconButton color='primary' onClick={onRemove}>
                    <Icon>delete</Icon>
                </IconButton>
            </Box>
            {children}

        </Box>
    );
};

export default RecipeLineWrapper;
